import DefaultLayout from "@/layouts/Default"
import OrderSummaryCard from "../components/OrderSummaryCard"
import { useEffect, useRef, useState } from "react"
import useSnap from "@/hooks/useSnap"
import CartAPI from "@/app/api/di-sana/cart/cart"
import CheckoutAPI from "@/app/api/di-sana/transaction/checkout/checkout"
import { useGlobalContext } from "@/global/GlobalContext"
import FormContainer from "../components/FormContainer"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import { formatNumber } from "@/app/utils/helpers"
import clsx from "clsx"
import { useDispatch } from "react-redux"
import { loadOrderCount } from "@/app/redux/features/order/orderSlice"
import CryptoHelper from "@/app/utils/crypto"
import Cookies from "js-cookie"
import ContainerSkeleton from "@/components/skeletons/ContainerSkeleton"
import { useNavigate } from "react-router-dom"
const cartApi = new CartAPI()
const checkoutApi = new CheckoutAPI()
const cryptoHelper = new CryptoHelper()

const Payment = () => {
  const { notifyError } = useGlobalContext()
  const navigate = useNavigate()
  const [isCheckOut, setIsCheckOut] = useState(false)
  const [snapToken, setSnapToken] = useState("")
  const [purchaseItems, setPurchaseItems] = useState([])
  const [productIds, setProductIds] = useState([])
  const [onReq, setOnReq] = useState(false)
  const [courier, setCourier] = useState({})
  const { snapPopUp } = useSnap()
  const subTotal = useRef(0)
  const dispatch = useDispatch()

  useEffect(() => {
    getPurchaseItems()
  }, [])

  useEffect(() => {
    if (purchaseItems.length > 0) {
      let tempSubTotal = 0
      const ids = []

      purchaseItems.map((val) => {
        tempSubTotal += val.total_price
        ids.push(val.product.id)
      })

      Cookies.get("shippingDetail") && setCourier(cryptoHelper.decrypt(Cookies.get("shippingDetail")))

      subTotal.current = tempSubTotal
      setProductIds(ids)
      setOnReq(false)
    }
  }, [purchaseItems])

  useEffect(() => {
    if (snapToken) snapPopUp(snapToken)
  }, [snapToken])

  const purchaseNow = async (formData) => {
    if (snapToken) {
      snapPopUp(snapToken)
    } else {
      await checkOutProducts()
    }
  }

  // API request
  const getPurchaseItems = async () => {
    setOnReq(true)
    try {
      let param = {
        is_checked: 1,
        // page: page.current
      }
      // TODO: tambahkan tampilan pagination
      const { data } = await cartApi.getWithPagination(param)
      if (data.data.carts.length == 0) {
        notifyError("No items in cart to proceed to payment.")
        navigate("/cart")
        return
      }
      setPurchaseItems(data.data.carts);
      // lastPage.current = data.data.last_page
    } catch (err) {
      notifyError(err)
    }
  }

  const checkOutProducts = async () => {
    setIsCheckOut(true)

    try {
      const param = {
        shipping_cost_id: courier.id
      }

      const { data } = await checkoutApi.processSnapToken(param)
      if (data.code == 200) {
        await dispatch(loadOrderCount()).unwrap()
        setSnapToken(data.data.snap_token)
      }
    } catch (err) {
      notifyError("There was an error processing your payment. Please try again later.")
    }

    setIsCheckOut(false)
  }

  return (
    <>
      <DefaultLayout noHero bgColor="bg-white">
        <section className="pb-10">
          <div className="grid lg:grid-cols-[1.5fr_1fr] lg:self-start gap-8 mt-12 px-4 md:px-12 lg:px-24">
            <div>
              <FormContainer title="Detail Order" custCls="w-full overflow-y-auto">
                <div>
                  {/* TODO: cek skeleton */}
                  {onReq ?
                    <div className="w-full flex justify-between items-center">
                      <div className="py-5 px-3 md:px-6">
                        <div className="flex">
                          <ContainerSkeleton custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" custCls="mr-4 lg:mr-8" />
                          <div className="mt-2">
                            <ContainerSkeleton custCls="mb-1" custH="h-[18px] sm:h-5 lg:h-6" custW="w-36" />
                            <ContainerSkeleton custH="h-4" custW="w-36" />
                          </div>
                        </div>
                      </div>
                      <div className="py-5 px-3 md:px-6 w-1/2">
                        <ContainerSkeleton custH="h-[18px] md:h-5" custW="w-full" />
                      </div>
                    </div>
                    :
                    purchaseItems &&
                    purchaseItems.map((p, i) =>
                      <div key={i} className={clsx("w-full flex justify-between items-center", { "border-b-[1.5px] border-b-[#bc9c5c]": i < purchaseItems.length - 1 })}>
                        <div className="py-5 px-3 md:px-6">
                          <div className="flex">
                            <div className="mr-4 lg:mr-8">
                              <ImageSkeleton src={p.product.photo} isDarker custCls="object-cover h-[90px] sm:h-[100px] md:h-[148px] w-[110px] sm:w-[130px] md:w-[190px] border-2 border-[#dcd6d2]" custH="h-[90px] sm:h-[100px] md:h-[148px]" custW="w-[110px] sm:w-[130px] md:w-[190px]" />
                            </div>
                            <div className="mt-2">
                              <span className="text-[#6e605d] font-agcasmlt font-normal text-lg sm:text-xl lg:text-2xl">{p.product.name}</span>
                              <span className="block text-[#6e6060] font-light font-agcasmlt text-base opacity-80">Quantity: {p.qty}</span>
                            </div>
                          </div>
                        </div>
                        <div className="py-5 px-3 md:px-6">
                          <div className="flex justify-center">
                            <span className="text-[#6e605d] font-light font-agcasmlt text-lg md:text-xl">IDR {formatNumber(p.total_price)}</span>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </FormContainer>
              {/* TODO: add pagination */}
            </div>
            <OrderSummaryCard isCalculating={onReq} sendDataToParent={purchaseNow} isSubmitForm={isCheckOut} subTotal={subTotal.current} deliveryFee={courier.cost} pageName="checkout" btnName="Purchase Now" custContainerCls="self-start md:top-16 sticky" />
          </div>
        </section>
      </DefaultLayout>
    </>
  )
}

export default Payment